import { ColumnProps } from 'antd/lib/table'
import { IAttribute } from '@core/api/Products/types'
import { LYSCard, LYSTable, LYSTypography } from '@core/components/Primitives'
import { useTranslation } from '@core/i18n/i18n'
import { useProductDetailContext } from '@core/utils/models/product/ProductContext'
import style from './index.module.less'

const SimpleAttributesTable = () => {
  const { product, variant } = useProductDetailContext() || {}
  const { t } = useTranslation()

  const productAttributes = product?.clientFields.attributes

  if (!product || !variant || !productAttributes?.length) {
    return null
  }

  const columns: Array<ColumnProps<any>> = [
    {
      dataIndex: 'attribute',
      key: 'attribute',
      align: 'left',
    },
    {
      dataIndex: 'value',
      key: 'value',
      align: 'left',
      className: `${style.valueColumn}`,
    },
  ]

  const data = productAttributes.map((attribute: IAttribute) => ({
    key: attribute.key,
    attribute: attribute.label,
    value: attribute.value,
  }))

  return (
    <LYSCard bordered={false}>
      <LYSTypography.Title level={3} visualAppearance={'h4'}>
        {t('productDetail.attribute')}
      </LYSTypography.Title>
      <LYSTable
        pagination={false}
        columns={columns}
        dataSource={data}
        showHeader={false}
        bordered={true}
        size={'small'}
        className={style.table}
      />
    </LYSCard>
  )
}

export default SimpleAttributesTable
